import { ProcessMode } from '@resistapp/common/types';

type WithStepAbundances = {
  beforeAbundances: unknown[] | undefined;
  afterAbundances: unknown[] | undefined;
};

export function getEffectiveStepProcessModeForComplexProcess(
  stepDatum: WithStepAbundances,
  defaultProcessMode: ProcessMode,
): ProcessMode.BEFORE | ProcessMode.AFTER {
  // `processMode` is a legacy global lens built for simple two-step WWTP flows (raw -> treated).
  // In complex process graphs, individual steps are not inherently "before" or "after", and
  // each step may only have one side populated. For step-level pills, prefer whichever side
  // actually has data so valid step metrics are not hidden by the global mode.
  const preferredMode = defaultProcessMode === ProcessMode.AFTER ? ProcessMode.AFTER : ProcessMode.BEFORE;
  const preferredAbundances = preferredMode === ProcessMode.AFTER ? stepDatum.afterAbundances : stepDatum.beforeAbundances;
  if (preferredAbundances?.length) {
    return preferredMode;
  }

  const fallbackMode = preferredMode === ProcessMode.AFTER ? ProcessMode.BEFORE : ProcessMode.AFTER;
  const fallbackAbundances = fallbackMode === ProcessMode.AFTER ? stepDatum.afterAbundances : stepDatum.beforeAbundances;
  if (fallbackAbundances?.length) {
    return fallbackMode;
  }

  return preferredMode;
}
